import axios from 'axios'
import { Message } from 'element-ui'

const request = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '',
  timeout: 60000
})

request.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = 'Bearer ' + token
    }
    return config
  },
  error => Promise.reject(error)
)

function loginExpired(message) {
  const text = String(message || '')
  return text.includes('JWT expired') || text.includes('登录已过期')
}

function goLogin() {
  localStorage.removeItem('token')
  localStorage.removeItem('userInfo')
  localStorage.removeItem('user')
  const path = window.location.pathname || ''
  if (path === '/login' || path.endsWith('/login')) return
  window.location.replace('/login')
}

request.interceptors.response.use(
  response => {
    const data = response.data
    if (data && loginExpired(data.message)) {
      goLogin()
      return Promise.reject(new Error('登录已过期，请重新登录'))
    }
    return data
  },
  error => {
    const silent = error.config && error.config.silentError
    if (error.response && (error.response.status === 401 || loginExpired(error.response.data && error.response.data.message))) {
      goLogin()
    } else if (!silent && loginExpired(error.message)) {
      // 已在成功回调里提示并跳转
    } else if (!silent) {
      const msg = (error.response && error.response.data && error.response.data.message) || error.message
      Message.error('请求失败：' + msg)
    }
    return Promise.reject(error)
  }
)

export function getBaseURL() {
  return request.defaults.baseURL || ''
}

export default request
